export default __webpack_public_path__ + "static/media/Anuphan-SemiBold.465bfa68.woff2";